import { BaseColor } from '@prophecy/theme';
import { Badges } from '@prophecy/ui-v3/Badges';
import {
  CancelAttribution,
  CancelSourceEnum,
  TriggerAttribution,
  TriggerSourceEnum
} from 'frontend/core/src/data/apis/types';

type SourceBadgeConfig = { label: string; tone: `${BaseColor}` };

const UNKNOWN_SOURCE: SourceBadgeConfig = { label: 'Unknown', tone: BaseColor.gray };

const TRIGGER_SOURCE_BADGES: Record<TriggerSourceEnum, SourceBadgeConfig> = {
  [TriggerSourceEnum.USER]: { label: 'User', tone: BaseColor.blue },
  [TriggerSourceEnum.SCHEDULE]: { label: 'Schedule', tone: BaseColor.primary },
  [TriggerSourceEnum.API]: { label: 'API', tone: BaseColor.secondary },
  [TriggerSourceEnum.CLI]: { label: 'CLI', tone: BaseColor.grayBlue },
  [TriggerSourceEnum.PARENT_RUN]: { label: 'Parent run', tone: BaseColor.orange }
};

const CANCEL_SOURCE_BADGES: Record<CancelSourceEnum, SourceBadgeConfig> = {
  [CancelSourceEnum.USER]: { label: 'User', tone: BaseColor.blue },
  [CancelSourceEnum.SCHEDULE_POLICY]: { label: 'Schedule policy', tone: BaseColor.warning },
  [CancelSourceEnum.PARENT_RUN]: { label: 'Parent run', tone: BaseColor.orange }
};

function SourceBadge({ label, tone }: SourceBadgeConfig) {
  return (
    <Badges variant='pillLight' tone={tone} data-test-id={`run-source-badge-${label.toLowerCase().replace(/ /g, '-')}`}>
      {label}
    </Badges>
  );
}

export function TriggerSourceBadge({ source }: { source: TriggerAttribution['source'] }) {
  return <SourceBadge {...(TRIGGER_SOURCE_BADGES[source as TriggerSourceEnum] ?? UNKNOWN_SOURCE)} />;
}

export function CancelSourceBadge({ source }: { source: CancelAttribution['source'] }) {
  return <SourceBadge {...(CANCEL_SOURCE_BADGES[source as CancelSourceEnum] ?? UNKNOWN_SOURCE)} />;
}
